/**
 * WB4.3-S5 — Unified workbench toast API (WorkbenchNotificationHost registers message API).
 */

import type { MessageInstance } from 'antd/es/message/interface';
import { showMessageWithApi } from '../../../utils/messageHelpers';
import { showWorkbenchInlineEditToast } from './surfaces/workbench-inline-edit-toast';

let registeredApi: MessageInstance | null = null;

export function registerWorkbenchNotificationApi(api: MessageInstance | null): void {
  registeredApi = api;
}

function requireApi(): MessageInstance {
  if (!registeredApi) {
    throw new Error(
      'Workbench notification API is not registered. Mount WorkbenchNotificationHost in BusinessWorkbenchShell.'
    );
  }
  return registeredApi;
}

export function showWorkbenchInfo(content: string, duration: number = 3): void {
  showMessageWithApi(requireApi(), content, { type: 'info', duration });
}

export function showWorkbenchSuccess(content: string, duration: number = 3): void {
  showMessageWithApi(requireApi(), content, { type: 'success', duration });
}

export function showWorkbenchError(content: string, duration: number = 3): void {
  showMessageWithApi(requireApi(), content, { type: 'error', duration });
}

export function showWorkbenchInlineEditUndoToast(
  fieldLabel: string,
  onUndo: () => void | Promise<void>
): void {
  showWorkbenchInlineEditToast(requireApi(), fieldLabel, onUndo);
}
